import Parse from "parse";

//***** Entry Code { *****//
export const confirmEntryCode = async (introInCode) => {
  // KST 기준 오늘 날짜
  const now = new Date();
  const kst = new Date(now.getTime() + 9 * 60 * 60 * 1000);
  const today = kst.toISOString().slice(0, 10);

  const EntryCode = Parse.Object.extend("Silence_Code");
  const query = new Parse.Query(EntryCode);
  query.equalTo("entryCode", introInCode); // 입장코드 일치
  query.equalTo("useDate", today); // 오늘 날짜 일치

  const entryCodeObj = await query.first();

  // 코드 없음 or 오늘 날짜 아님
  if (!entryCodeObj) {
    throw new Error("유효하지 않은 입장코드입니다.");
  }

  // usageCount +1 (통계용 — 재입장 막지 않음)
  entryCodeObj.increment("usageCount");
  await entryCodeObj.save();
};
//***** } Entry Code *****//
